"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class Gateway extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.site = null;
        this.objectTypeName = 'gateway';
        this._virtualFrom = initParams.virtual_from;
        this._updateState = initParams.update_state;
        this._locationId = initParams.location_id;
        this._locationName = initParams.location_name;
        this._timezone = initParams.timezone;
        this._locationMetadata = initParams.location_metadata;
        this._targetVersion = initParams.target_version;
        this._name = initParams.name;
        this._scanning = initParams.scanning;
        this._status = initParams.status;
        this._physicalGatewayId = initParams.physical_gateway_id;
        this._ethernetMac = initParams.ethernet_mac;
        this._wlanMac = initParams.wlan_mac;
        this._lastContacted = initParams.last_contacted;
        this._siteId = initParams.site_id;
        this._siteName = initParams.site_name;
        this._connectionType = initParams.connection_type;
        this._powerSource = initParams.power_source;
        this._charge = initParams.charge;
        this._wifiNetwork = initParams.wifi_network;
        this._activeConnection = initParams.active_connection;
        this.__permission = initParams._permission;
        this._wifiStrength = initParams.wifi_strength;
        this._mobileStrength = initParams.mobile_strength;
        this._imsi = initParams.imsi;
        this._ipAddress = initParams.ip_address;
        this._serialNumber = initParams.serial_number;
        this._modelNumber = initParams.model_number;
        this._disconnected = initParams.disconnected;
        this._staging = initParams.staging;
        this._beta = initParams.beta;
        this._debugMode = initParams.debug_mode;
        this._enhancedLogging = initParams.enhanced_logging;
        this._zigbeeDisabled = initParams.zigbee_disabled;
        this._doReboot = initParams.do_reboot;
        this._doZigbeeReset = initParams.do_zigbee_reset;
        this._getTrustedList = initParams.get_trusted_list;
        this._installationCode = initParams.installation_code;
        this._version = initParams.version;
        this._updateSlot = initParams.update_slot;
        this._type = initParams.type;
        this._gatewayType = initParams.gateway_type;
        this._imei = initParams.imei;
        this._intermittent = initParams.intermittent;
        this._lowSignal = initParams.low_signal;
        this._fault = initParams.fault;
        this._anomaly = initParams.anomaly;
        this._modbusMessageRec = initParams.modbus_message_rec;
        this._modbusMessage = initParams.modbus_message;
        this._modbusParams = initParams.modbus_params;
        this._modbusSubscribe = initParams.modbus_subscribe;
    }
    set virtualFrom(value) {
        console.error('Do not set objects this way');
    }
    setVirtualFrom(value) {
        return this.dataService.updateGateway(this.id, { virtual_from: value }, this);
    }
    get virtualFrom() {
        return this._virtualFrom;
    }
    set updateState(value) {
        console.error('Do not set objects this way');
    }
    setUpdateState(value) {
        return this.dataService.updateGateway(this.id, { update_state: value }, this);
    }
    get updateState() {
        return this._updateState;
    }
    set locationId(value) {
        console.error('Do not set objects this way');
    }
    setLocationId(value) {
        return this.dataService.updateGateway(this.id, { location_id: value }, this);
    }
    get locationId() {
        return this._locationId;
    }
    set locationName(value) {
        console.error('Do not set objects this way');
    }
    setLocationName(value) {
        return this.dataService.updateGateway(this.id, { location_name: value }, this);
    }
    get locationName() {
        return this._locationName;
    }
    set timezone(value) {
        console.error('Do not set objects this way');
    }
    setTimezone(value) {
        return this.dataService.updateGateway(this.id, { timezone: value }, this);
    }
    get timezone() {
        return this._timezone;
    }
    set locationMetadata(value) {
        console.error('Do not set objects this way');
    }
    setLocationMetadata(value) {
        return this.dataService.updateGateway(this.id, { location_metadata: value }, this);
    }
    get locationMetadata() {
        return this._locationMetadata;
    }
    set targetVersion(value) {
        console.error('Do not set objects this way');
    }
    setTargetVersion(value) {
        return this.dataService.updateGateway(this.id, { target_version: value }, this);
    }
    get targetVersion() {
        return this._targetVersion;
    }
    set name(value) {
        console.error('Do not set objects this way');
    }
    setName(value) {
        return this.dataService.updateGateway(this.id, { name: value }, this);
    }
    get name() {
        return this._name;
    }
    set scanning(value) {
        console.error('Do not set objects this way');
    }
    setScanning(value) {
        return this.dataService.updateGateway(this.id, { scanning: value }, this);
    }
    get scanning() {
        return this._scanning;
    }
    set status(value) {
        console.error('Do not set objects this way');
    }
    setStatus(value) {
        return this.dataService.updateGateway(this.id, { status: value }, this);
    }
    get status() {
        return this._status;
    }
    set physicalGatewayId(value) {
        console.error('Do not set objects this way');
    }
    setPhysicalGatewayId(value) {
        return this.dataService.updateGateway(this.id, { physical_gateway_id: value }, this);
    }
    get physicalGatewayId() {
        return this._physicalGatewayId;
    }
    set ethernetMac(value) {
        console.error('Do not set objects this way');
    }
    setEthernetMac(value) {
        return this.dataService.updateGateway(this.id, { ethernet_mac: value }, this);
    }
    get ethernetMac() {
        return this._ethernetMac;
    }
    set wlanMac(value) {
        console.error('Do not set objects this way');
    }
    setWlanMac(value) {
        return this.dataService.updateGateway(this.id, { wlan_mac: value }, this);
    }
    get wlanMac() {
        return this._wlanMac;
    }
    set lastContacted(value) {
        console.error('Do not set objects this way');
    }
    setLastContacted(value) {
        return this.dataService.updateGateway(this.id, { last_contacted: value }, this);
    }
    get lastContacted() {
        return this._lastContacted;
    }
    set siteId(value) {
        console.error('Do not set objects this way');
    }
    setSiteId(value) {
        return this.dataService.updateGateway(this.id, { site_id: value }, this);
    }
    get siteId() {
        return this._siteId;
    }
    set siteName(value) {
        console.error('Do not set objects this way');
    }
    setSiteName(value) {
        return this.dataService.updateGateway(this.id, { site_name: value }, this);
    }
    get siteName() {
        return this._siteName;
    }
    set connectionType(value) {
        console.error('Do not set objects this way');
    }
    setConnectionType(value) {
        return this.dataService.updateGateway(this.id, { connection_type: value }, this);
    }
    get connectionType() {
        return this._connectionType;
    }
    set powerSource(value) {
        console.error('Do not set objects this way');
    }
    setPowerSource(value) {
        return this.dataService.updateGateway(this.id, { power_source: value }, this);
    }
    get powerSource() {
        return this._powerSource;
    }
    set charge(value) {
        console.error('Do not set objects this way');
    }
    setCharge(value) {
        return this.dataService.updateGateway(this.id, { charge: value }, this);
    }
    get charge() {
        return this._charge;
    }
    set wifiNetwork(value) {
        console.error('Do not set objects this way');
    }
    setWifiNetwork(value) {
        return this.dataService.updateGateway(this.id, { wifi_network: value }, this);
    }
    get wifiNetwork() {
        return this._wifiNetwork;
    }
    set activeConnection(value) {
        console.error('Do not set objects this way');
    }
    setActiveConnection(value) {
        return this.dataService.updateGateway(this.id, { active_connection: value }, this);
    }
    get activeConnection() {
        return this._activeConnection;
    }
    set _permission(value) {
        console.error('Do not set objects this way');
    }
    set_permission(value) {
        return this.dataService.updateGateway(this.id, { _permission: value }, this);
    }
    get _permission() {
        return this.__permission;
    }
    set wifiStrength(value) {
        console.error('Do not set objects this way');
    }
    setWifiStrength(value) {
        return this.dataService.updateGateway(this.id, { wifi_strength: value }, this);
    }
    get wifiStrength() {
        return this._wifiStrength;
    }
    set mobileStrength(value) {
        console.error('Do not set objects this way');
    }
    setMobileStrength(value) {
        return this.dataService.updateGateway(this.id, { mobile_strength: value }, this);
    }
    get mobileStrength() {
        return this._mobileStrength;
    }
    set imsi(value) {
        console.error('Do not set objects this way');
    }
    setImsi(value) {
        return this.dataService.updateGateway(this.id, { imsi: value }, this);
    }
    get imsi() {
        return this._imsi;
    }
    set ipAddress(value) {
        console.error('Do not set objects this way');
    }
    setIpAddress(value) {
        return this.dataService.updateGateway(this.id, { ip_address: value }, this);
    }
    get ipAddress() {
        return this._ipAddress;
    }
    set serialNumber(value) {
        console.error('Do not set objects this way');
    }
    setSerialNumber(value) {
        return this.dataService.updateGateway(this.id, { serial_number: value }, this);
    }
    get serialNumber() {
        return this._serialNumber;
    }
    set modelNumber(value) {
        console.error('Do not set objects this way');
    }
    setModelNumber(value) {
        return this.dataService.updateGateway(this.id, { model_number: value }, this);
    }
    get modelNumber() {
        return this._modelNumber;
    }
    set disconnected(value) {
        console.error('Do not set objects this way');
    }
    setDisconnected(value) {
        return this.dataService.updateGateway(this.id, { disconnected: value }, this);
    }
    get disconnected() {
        return this._disconnected;
    }
    set staging(value) {
        console.error('Do not set objects this way');
    }
    setStaging(value) {
        return this.dataService.updateGateway(this.id, { staging: value }, this);
    }
    get staging() {
        return this._staging;
    }
    set beta(value) {
        console.error('Do not set objects this way');
    }
    setBeta(value) {
        return this.dataService.updateGateway(this.id, { beta: value }, this);
    }
    get beta() {
        return this._beta;
    }
    set debugMode(value) {
        console.error('Do not set objects this way');
    }
    setDebugMode(value) {
        return this.dataService.updateGateway(this.id, { debug_mode: value }, this);
    }
    get debugMode() {
        return this._debugMode;
    }
    set enhancedLogging(value) {
        console.error('Do not set objects this way');
    }
    setEnhancedLogging(value) {
        return this.dataService.updateGateway(this.id, { enhanced_logging: value }, this);
    }
    get enhancedLogging() {
        return this._enhancedLogging;
    }
    set zigbeeDisabled(value) {
        console.error('Do not set objects this way');
    }
    setZigbeeDisabled(value) {
        return this.dataService.updateGateway(this.id, { zigbee_disabled: value }, this);
    }
    get zigbeeDisabled() {
        return this._zigbeeDisabled;
    }
    set doReboot(value) {
        console.error('Do not set objects this way');
    }
    setDoReboot(value) {
        return this.dataService.updateGateway(this.id, { do_reboot: value }, this);
    }
    get doReboot() {
        return this._doReboot;
    }
    set doZigbeeReset(value) {
        console.error('Do not set objects this way');
    }
    setDoZigbeeReset(value) {
        return this.dataService.updateGateway(this.id, { do_zigbee_reset: value }, this);
    }
    get doZigbeeReset() {
        return this._doZigbeeReset;
    }
    set getTrustedList(value) {
        console.error('Do not set objects this way');
    }
    setGetTrustedList(value) {
        return this.dataService.updateGateway(this.id, { get_trusted_list: value }, this);
    }
    get getTrustedList() {
        return this._getTrustedList;
    }
    set installationCode(value) {
        console.error('Do not set objects this way');
    }
    setInstallationCode(value) {
        return this.dataService.updateGateway(this.id, { installation_code: value }, this);
    }
    get installationCode() {
        return this._installationCode;
    }
    set version(value) {
        console.error('Do not set objects this way');
    }
    setVersion(value) {
        return this.dataService.updateGateway(this.id, { version: value }, this);
    }
    get version() {
        return this._version;
    }
    set updateSlot(value) {
        console.error('Do not set objects this way');
    }
    setUpdateSlot(value) {
        return this.dataService.updateGateway(this.id, { update_slot: value }, this);
    }
    get updateSlot() {
        return this._updateSlot;
    }
    set type(value) {
        console.error('Do not set objects this way');
    }
    setType(value) {
        return this.dataService.updateGateway(this.id, { type: value }, this);
    }
    get type() {
        return this._type;
    }
    set gatewayType(value) {
        console.error('Do not set objects this way');
    }
    setGatewayType(value) {
        return this.dataService.updateGateway(this.id, { gateway_type: value }, this);
    }
    get gatewayType() {
        return this._gatewayType;
    }
    set imei(value) {
        console.error('Do not set objects this way');
    }
    setImei(value) {
        return this.dataService.updateGateway(this.id, { imei: value }, this);
    }
    get imei() {
        return this._imei;
    }
    set intermittent(value) {
        console.error('Do not set objects this way');
    }
    setIntermittent(value) {
        return this.dataService.updateGateway(this.id, { intermittent: value }, this);
    }
    get intermittent() {
        return this._intermittent;
    }
    set lowSignal(value) {
        console.error('Do not set objects this way');
    }
    setLowSignal(value) {
        return this.dataService.updateGateway(this.id, { low_signal: value }, this);
    }
    get lowSignal() {
        return this._lowSignal;
    }
    set fault(value) {
        console.error('Do not set objects this way');
    }
    setFault(value) {
        return this.dataService.updateGateway(this.id, { fault: value }, this);
    }
    get fault() {
        return this._fault;
    }
    set anomaly(value) {
        console.error('Do not set objects this way');
    }
    setAnomaly(value) {
        return this.dataService.updateGateway(this.id, { anomaly: value }, this);
    }
    get anomaly() {
        return this._anomaly;
    }
    set modbusMessageRec(value) {
        console.error('Do not set objects this way');
    }
    setModbusMessageRec(value) {
        return this.dataService.updateGateway(this.id, { modbus_message_rec: value }, this);
    }
    get modbusMessageRec() {
        return this._modbusMessageRec;
    }
    set modbusMessage(value) {
        console.error('Do not set objects this way');
    }
    setModbusMessage(value) {
        return this.dataService.updateGateway(this.id, { modbus_message: value }, this);
    }
    get modbusMessage() {
        return this._modbusMessage;
    }
    set modbusParams(value) {
        console.error('Do not set objects this way');
    }
    setModbusParams(value) {
        return this.dataService.updateGateway(this.id, { modbus_params: value }, this);
    }
    get modbusParams() {
        return this._modbusParams;
    }
    set modbusSubscribe(value) {
        console.error('Do not set objects this way');
    }
    setModbusSubscribe(value) {
        return this.dataService.updateGateway(this.id, { modbus_subscribe: value }, this);
    }
    get modbusSubscribe() {
        return this._modbusSubscribe;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateGateway(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
    delete() {
        return this.dataService.deleteGateway(this.id, this);
    }
}
exports.default = Gateway;
//# sourceMappingURL=gateway.js.map